import React, { useEffect, useState } from 'react';
import { Pagination, ReferralInvitedUser } from '../../../interfaces';
import { ConfigProvider, Pagination as AntPagination, TableColumnsType } from 'antd';
import moment from 'jalali-moment';
import { getReferralInvitedUsers } from '../referral.service';
import { Table } from '../../components';
import fa_IR from 'antd/locale/fa_IR';
import { Card } from '../../../utilities/components';

export const ReferralInvitedUsers = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [invitedUsers, setInvitedUsers] = useState<Pagination<ReferralInvitedUser>>();
    const [page, setPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(10);

    const columns: TableColumnsType<any> = [
        {
            title: 'ردیف',
            dataIndex: 'id',
            key: 'id',
            render: (text, record: ReferralInvitedUser, i) => <span className={'font-medium text-sm'}>{i + 1}</span>,
        },
        {
            title: 'شماره همراه',
            dataIndex: 'phoneNumber',
            key: 'phoneNumber',
            render: (text, record: ReferralInvitedUser) => (
                <span className={'font-medium text-sm'}>{record?.phoneNumber}</span>
            ),
        },
        {
            title: 'سطح',
            dataIndex: 'levelTitle',
            key: 'levelTitle',
            render: (pair, record: ReferralInvitedUser) => (
                <span className={'text-sm font-medium'}>{record?.levelTitle}</span>
            ),
        },
        {
            title: 'تاریخ',
            dataIndex: 'createdOn',
            key: 'createdOn',
            render: (text, record: ReferralInvitedUser) => (
                <span className={'font-medium text-sm'}>
                    {moment.utc(record?.createdOn).locale('fa').local().format('jD jMMMM jYYYY، ساعت HH:mm')}
                </span>
            ),
        },
    ];

    const handlePageChange = (page: number, pageSize: number) => {
        setPage(page);
        setPageSize(pageSize);
    };

    const fetchData = (page: number, pageSize: number) => {
        getReferralInvitedUsers(setLoading, setInvitedUsers, page, pageSize);
    };

    useEffect(() => {
        fetchData(page, pageSize);
    }, [page, pageSize]);

    return (
        <Card size={'small'} title={'دوست های من'} titleDivider noPadding className={'w-full mt-4'}>
            <Table
                className={'border-0'}
                columns={columns}
                dataSource={invitedUsers?.items}
                loading={loading}
                rowKey="id"
                pagination={false}
            />
            <ConfigProvider locale={fa_IR}>
                <AntPagination
                    current={page}
                    pageSize={pageSize}
                    total={invitedUsers?.pagination.totalCount}
                    onChange={handlePageChange}
                    className="mt-4 justify-center"
                    style={{ direction: 'ltr' }}
                    showSizeChanger={true}
                    onShowSizeChange={(current, size) => handlePageChange(current, size)}
                />
            </ConfigProvider>
        </Card>
    );
};
